import { resolveAdpStaticAssetUrl } from './adpDataSources.api'
import type { AdpDataSource } from './adpDataSources.types'

export type PaletteBucket = 'fileSystem' | 'database' | 'restApi' | 'nosql'

export type PaletteConnectorItem = {
  id: string
  label: string
  image: string
  dataSourceId: number
}

export type BucketedPaletteConnectors = Record<PaletteBucket, PaletteConnectorItem[]>

const EMPTY: BucketedPaletteConnectors = {
  fileSystem: [],
  database: [],
  restApi: [],
  nosql: [],
}

/**
 * Maps API `data_source_type` to sidebar sections (File System, Database, Rest APIs, No SQL).
 */
export function paletteBucketForDataSourceType(dataSourceType: string): PaletteBucket {
  const t = dataSourceType.trim().toUpperCase().replace(/\s+/g, ' ')
  if (t === 'FILE' || t === 'FILESYSTEM') return 'fileSystem'
  if (t === 'RDBMS') return 'database'
  if (t === 'API' || t === 'REAL TIME SOURCE') return 'restApi'
  if (t === 'NO SQL' || t === 'NOSQL') return 'nosql'
  return 'database'
}

export function bucketAdpDataSources(
  dataSources: AdpDataSource[],
  adpApiBase: string
): BucketedPaletteConnectors {
  const out: BucketedPaletteConnectors = {
    fileSystem: [],
    database: [],
    restApi: [],
    nosql: [],
  }

  const sorted = [...dataSources].sort((a, b) =>
    a.data_source_name.localeCompare(b.data_source_name, undefined, { sensitivity: 'base' })
  )

  for (const ds of sorted) {
    const bucket = paletteBucketForDataSourceType(ds.data_source_type)
    const id = ds.data_source_instance?.trim() || `ds_${ds.data_source_id}`
    out[bucket].push({
      id,
      label: ds.data_source_name,
      image: resolveAdpStaticAssetUrl(adpApiBase, ds.image_link),
      dataSourceId: ds.data_source_id,
    })
  }

  return out
}

export function emptyBucketedConnectors(): BucketedPaletteConnectors {
  return {
    fileSystem: [...EMPTY.fileSystem],
    database: [...EMPTY.database],
    restApi: [...EMPTY.restApi],
    nosql: [...EMPTY.nosql],
  }
}
